import { Vue } from 'vue-property-decorator'
import { LoginApi } from '@/api/methods/activate/LoginApi'
import { ApiResponseActivateLogin } from '@/api/responses/activate/login'

/**
 * 仮ユーザログイン処理
 */
export default class TemporaryLoginMethods {
  /** 二重呼び出し防止用フラグ */
  private static loginApiCalled = false

  /**
   * ログイン処理
   *
   * @param loginId ログインID
   * @param password パスワード
   * @returns ログイン結果(成功/失敗、二重呼び出しによって処理がスキップされた場合はnullを返す)
   */
  public static async login(loginId: string, password: string): Promise<boolean | null> {
    // 二重呼び出し防止
    if (this.loginApiCalled) {
      return null
    }
    this.loginApiCalled = true

    // cookieの認証情報を削除
    Vue.prototype.$appCookies.removeAuth()

    let loginResponse!: ApiResponseActivateLogin

    try {
      // API実行
      loginResponse = await LoginApi.login(loginId, password)
      // cookieに認証情報を保存
      await Vue.prototype.$appCookies.auth.set({
        accessToken: loginResponse.token,
        uid: loginResponse.uid,
        client: loginResponse.client,
      })
    } catch {
      return false
    } finally {
      // 再実行可能にする
      this.loginApiCalled = false
    }

    return true
  }
}
